import React, { useState, useEffect, useContext } from 'react';
import {
	ICountry,
	ICustomerCountry,
	OfferContext,
	getCountriesByCustomer,
	TollService,
	IOfferContext,
	IPlatesValidatedState,
} from '@adac-mp/shared';
import { PlatesInputConfirmation } from '../../index';

interface IEnterPlatesProps {
	plates: IPlatesValidatedState;
	hasSpecialPlates?: boolean;
	border?: boolean;
	withAutoFocus?: boolean;
	insideOfModal?: boolean;
	countryCode?: string;
	hasError?: boolean;
	customerCountries?: ICustomerCountry[];
	setPlates: (state: IPlatesValidatedState) => void;
	setHideModal?: (hideModal: boolean) => void;
}

export const EnterPlates = ({
	plates,
	hasSpecialPlates = false,
	border = false,
	withAutoFocus = false,
	insideOfModal = false,
	countryCode = 'DE',
	customerCountries = undefined,
	hasError = false,
	setPlates,
	setHideModal = () => {},
}: IEnterPlatesProps) => {
	const { allCountries, vignetteOffers, lang, updateAllCountries } = useContext<IOfferContext>(OfferContext);
	const [selectedCountry, setSelectedCountry] = useState<ICountry | undefined>(undefined);
	const [countries, setCountries] = useState<ICountry[] | []>([]);

	useEffect(() => {
		const fetchAllCountries = async () =>
			await TollService.getCountries(lang).then((data) => {
				updateAllCountries(data.countries);
			});

		if (!allCountries) {
			fetchAllCountries();
		}
	}, []);

	useEffect(() => {
		const initializeCountryData = (currentCustomerCountries: ICustomerCountry[]) => {
			if (allCountries) {
				const countriesByCustomer = getCountriesByCustomer(allCountries, currentCustomerCountries);
				setCountries(countriesByCustomer);
				setSelectedCountry(allCountries.find((c: ICountry) => c.isoCode === countryCode));
			}
		};

		if (customerCountries) {
			initializeCountryData(customerCountries);
		} else if (vignetteOffers.length > 0) {
			const { customerCountries: firstOfferCustomerCountries } = vignetteOffers[0];
			initializeCountryData(firstOfferCustomerCountries);
		}
	}, [allCountries, vignetteOffers]);

	return (
		<div className="flex flex-col gap-2 items-stretch">
			<PlatesInputConfirmation
				withAutoFocus={withAutoFocus}
				hasSpecialPlates={hasSpecialPlates}
				border={border}
				insideOfModal={insideOfModal}
				countries={countries}
				country={selectedCountry}
				plates={plates}
				setCountry={setSelectedCountry}
				setHideModal={setHideModal}
				hasError={hasError}
				onChange={setPlates}
			/>
		</div>
	);
};
